import { render, staticRenderFns } from "./EditClienteOVModal.vue?vue&type=template&id=120f569f&lang=pug"
import script from "./EditClienteOVModal.vue?vue&type=script&lang=js"
export * from "./EditClienteOVModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports